import { MenuItem } from '@mui/material';

import INSTANCE_CLASSES from '../../../instanceClasses';
import AZURE_RESOURCE_TYPES from './azureResourceTypes';

const cpu_instance_classes =
  import.meta.env.VITE_STAGE === 'dev'
    ? [
        <MenuItem value={'nano'}>Nano (4)</MenuItem>,
        <MenuItem value={INSTANCE_CLASSES.MICRO.value}>
          {INSTANCE_CLASSES.MICRO.label('(8)')}
        </MenuItem>,
        <MenuItem value={INSTANCE_CLASSES.SMALL.value}>
          {INSTANCE_CLASSES.SMALL.label('(16)')}
        </MenuItem>,
        <MenuItem value={INSTANCE_CLASSES.MEDIUM.value}>
          {INSTANCE_CLASSES.MEDIUM.label('(32)')}
        </MenuItem>,
        <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
          {INSTANCE_CLASSES.LARGE.label('(64)')}
        </MenuItem>,
        <MenuItem value={INSTANCE_CLASSES.XLARGE.value}>
          {INSTANCE_CLASSES.LARGE.label('(128)')}
        </MenuItem>,
      ]
    : [
        <MenuItem value={INSTANCE_CLASSES.MICRO.value}>
          {INSTANCE_CLASSES.MICRO.label('(8)')}
        </MenuItem>,
        <MenuItem value={INSTANCE_CLASSES.SMALL.value}>
          {INSTANCE_CLASSES.SMALL.label('(16)')}
        </MenuItem>,
        <MenuItem value={INSTANCE_CLASSES.MEDIUM.value}>
          {INSTANCE_CLASSES.MEDIUM.label('(32)')}
        </MenuItem>,
        <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
          {INSTANCE_CLASSES.LARGE.label('(64)')}
        </MenuItem>,
        <MenuItem value={INSTANCE_CLASSES.XLARGE.value}>
          {INSTANCE_CLASSES.LARGE.label('(128)')}
        </MenuItem>,
      ];

const RESOURCE_TYPE_MAPPING = {
  // [AZURE_RESOURCE_TYPES.V100]: {
  //   label: 'V100',
  //   instance_classes: [
  //     <MenuItem value={INSTANCE_CLASSES.MICRO.value}>
  //       {INSTANCE_CLASSES.MICRO.label('(1)')}
  //     </MenuItem>,
  //     <MenuItem value={INSTANCE_CLASSES.MEDIUM.value}>
  //       {INSTANCE_CLASSES.MEDIUM.label('(4)')}
  //     </MenuItem>,
  //     <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
  //       {INSTANCE_CLASSES.LARGE.label('(8)')}
  //     </MenuItem>,
  //   ],
  // },
  // [AZURE_RESOURCE_TYPES.T4]: {
  //   label: 'T4',
  //   instance_classes: [
  //     <MenuItem value={INSTANCE_CLASSES.MICRO.value}>
  //       {INSTANCE_CLASSES.MICRO.label('(1)')}
  //     </MenuItem>,
  //     <MenuItem value={INSTANCE_CLASSES.MEDIUM.value}>
  //       {INSTANCE_CLASSES.MEDIUM.label('(4)')}
  //     </MenuItem>,
  //     <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
  //       {INSTANCE_CLASSES.LARGE.label('(8)')}
  //     </MenuItem>,
  //   ],
  // },
  // [AZURE_RESOURCE_TYPES.L4]: {
  //   label: 'L4',
  //   instance_classes: [
  //     <MenuItem value={INSTANCE_CLASSES.MICRO.value}>
  //       {INSTANCE_CLASSES.MICRO.label('(1)')}
  //     </MenuItem>,
  //     <MenuItem value={INSTANCE_CLASSES.MEDIUM.value}>
  //       {INSTANCE_CLASSES.MEDIUM.label('(4)')}
  //     </MenuItem>,
  //     <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
  //       {INSTANCE_CLASSES.LARGE.label('(8)')}
  //     </MenuItem>,
  //   ],
  // },
  // [AZURE_RESOURCE_TYPES.A100]: {
  //   label: 'A100',
  //   instance_classes: [
  //     <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
  //       {INSTANCE_CLASSES.LARGE.label('(8)')}
  //     </MenuItem>,
  //   ],
  // },
  [AZURE_RESOURCE_TYPES.H100]: {
    label: 'H100',
    instance_classes: [
      <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
        {INSTANCE_CLASSES.LARGE.label('(8)')}
      </MenuItem>,
    ],
  },
  [AZURE_RESOURCE_TYPES.MI300X]: {
    label: 'Instinct MI300X',
    instance_classes: [
      <MenuItem value={INSTANCE_CLASSES.LARGE.value}>
        {INSTANCE_CLASSES.LARGE.label('(8)')}
      </MenuItem>,
    ],
  },
  [AZURE_RESOURCE_TYPES.CPU]: {
    label: 'CPU Only',
    instance_classes: cpu_instance_classes,
  },
};
export default RESOURCE_TYPE_MAPPING;
